import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSelect from "../LanguageSelect/LanguageSelect";
import AppName from "../AppName/AppName";
import {
  Section,
  Container,
  TextContainer,
  Text,
  Header,
  LinkLogo,
  Logo,
  RightHeader,
  IconAppNameContainer,
  Icon,
  SocialButtonsContainer,
  GoogleButton,
  AppleLink,
  AppleButton,
  Video,
  MainSectionImage,
} from "./MainSection.styles";
import MainScreenAnimations from "../MainScreenAnimations/MainScreenAnimations";
import logo from "../../assets/images/logo.svg";
import icon from "../../assets/images/icon.webp";
import mainSectionImage from "../../assets/images/mainSectionImage.webp";
import mainSectionImageBig from "../../assets/images/mainSectionImageBig.svg";
import useMainSection from "./MainSection.utils";
import mainVideo from "../../assets/video/mainVideo.mp4";

const MainSection = () => {
  const {
    buttonGoogle,
    buttonApple,
    googleHovered,
    googleUnhovered,
    appleHovered,
    appleUnhovered,
    width,
  } = useMainSection();
  const { t } = useTranslation();

  return (
    <Section>
      <Container>
        <Header>
          <LinkLogo to="/">
            <Logo src={logo} alt="logo" />
          </LinkLogo>
          <RightHeader>
            <LanguageSelect />
          </RightHeader>
        </Header>
        <IconAppNameContainer>
          <Icon src={icon} alt="icon" />
          <AppName />
        </IconAppNameContainer>
        <TextContainer>
          <Text>{t("description")}</Text>
        </TextContainer>
        <SocialButtonsContainer>
          <a
            href="https://play.google.com/store/apps/details?id=com.kidhab"
            target="_blank"
            rel="noreferrer"
          >
            <GoogleButton
              src={buttonGoogle}
              alt="google"
              onMouseEnter={googleHovered}
              onMouseLeave={googleUnhovered}
            />
          </a>
          <AppleLink
            href="https://apps.apple.com/ua/app/kidhab/id1550279631"
            target="_blank"
            rel="noreferrer"
          >
            <AppleButton
              src={buttonApple}
              alt="apple"
              onMouseEnter={appleHovered}
              onMouseLeave={appleUnhovered}
            />
          </AppleLink>
        </SocialButtonsContainer>
        {width >= 768 && (
          <>
            <Video>
              <video
                autoPlay={true}
                loop={true}
                muted={true}
                width="360px"
                style={{ borderRadius: "150px 0 0 150px" }}
              >
                <source src={mainVideo} type="video/mp4" />
              </video>
            </Video>
            <MainScreenAnimations />
          </>
        )}
        {width !== null && (
          <MainSectionImage
            src={width < 768 ? mainSectionImage : mainSectionImageBig}
            alt="main section"
          />
        )}
      </Container>
    </Section>
  );
};

export default MainSection;
